import { Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Iconify from '../Iconify';

const MachinesConcerneeListViewData = ({ chooseSingleMachine, machine, handleMachineClick, columnWidth, hasPermission, setMachineToRemove, setOpenRemoveMachine }) => {

  const handleClickToRemoveMachine = (event, machineId) => {
    event.stopPropagation();
    setMachineToRemove(machineId);
    setOpenRemoveMachine(true);
  };

  if (!machine) {
    return (
      <Box className='table_row'>
        <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.site }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.pole }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.metier }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.marque }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.serial_number }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#EA5E00', width: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
      </Box>
    );
  }

  return (
    <Box className='table_row' onClick={() => handleMachineClick(machine.id)}>
      <Box className='tableBodyCell' sx={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#EA5E00', minWidth: columnWidth.name, maxWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
        {hasPermission && !chooseSingleMachine &&
          <Iconify icon={'ep:remove'} width='23px' height='23px' onClick={(e) => handleClickToRemoveMachine(e, machine.id)} />
        }
        <Typography className='tableBodyTypography'>{machine?.name}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.site, maxWidth: columnWidth.site }}>
        <Typography className='tableBodyTypography'>{machine?.site?.name}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.pole, maxWidth: columnWidth.pole }}>
        <Typography className='tableBodyTypography'>{machine?.pole?.name}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.metier, maxWidth: columnWidth.metier }}>
        <Typography className='tableBodyTypography'>{machine?.machine_metier?.map((metier) => metier?.metier?.name).join(" - ") || 'N/A'}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.marque, maxWidth: columnWidth.marque }}>
        <Typography className='tableBodyTypography'>{machine?.marque?.name || 'N/A'}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.serial_number, maxWidth: columnWidth.serial_number, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        <Typography className='tableBodyTypography'>{machine?.serial_number || 'N/A'}</Typography>
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#EA5E00', minWidth: '50px', maxWidth: '50px' }}><Iconify icon={'ri:arrow-right-s-line'} /></Box>
    </Box>
  );
};

export default MachinesConcerneeListViewData;